import type { Service } from '@/lib/types';

export interface ServiceLabel {
  /** Short category word for telling apart services with the same name: «лазер», «шугаринг». */
  category: string;
  /** Name for a chip: the name, plus the category when another service shares it. */
  chip: string;
}

/** Labels per service id; `category` is set only when the name repeats across categories. */
export function serviceLabels(services: Service[]): Map<string, ServiceLabel> {
  const count = new Map<string, number>();
  for (const s of services) count.set(s.name.toLowerCase(), (count.get(s.name.toLowerCase()) ?? 0) + 1);
  return new Map(
    services.map((s) => {
      const dup = (count.get(s.name.toLowerCase()) ?? 0) > 1;
      const category = dup ? (s.category || '').split(/[\s/]+/)[0]!.toLowerCase() : '';
      return [s.id, { category, chip: category ? `${s.name} · ${category}` : s.name }];
    }),
  );
}
